import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import GroupedSelect from '../../../components/DemoTabs/GroupedSelect';
import SingalUserImageSelect from '../../../components/DemoTabs/SingalUserImageSelect';
import SettingsIcon from '@mui/icons-material/Settings';
import SingleDatePicker from '../../../components/Date-range-picker/SingleDatePicker';
import UnusualDataCard from './UnusualDataCard';
import UpgradeToGetStarted from '../../../components/UpgradeToGetStarted/UpgradeToGetStarted'
import { Link } from 'react-router-dom';
import DateRangePicker from '../../../components/Date-range-picker/DateRangePicker';


const UnusualActivity = () => {
    const [selectedProjects, setSelectedProjects] = useState([]);
    const projects = ['John Doe John Doe John Doe', 'Alice Johnson', 'Rahul Sharma', 'Deepa Nair'];

    const userList = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Michael Johnson', image: '' },
    ];

    const [selectedUser, setSelectedUser] = useState('');

    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
                <Typography component="a" href="/highlights" className="fw-semibold mb-0" sx={{ fontSize: '16px', color: '#1A1F36', display: 'flex', alignItems: 'center', lineHeight: '1', gap: '6px' }}>
                    <span><KeyboardArrowLeftIcon sx={{ fontSize: '16px', color: '#1760EC' }} /></span>
                    Insights</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
                <Typography className="fw-semibold mb-0" sx={{ fontSize: '24px', color: '#1A1F36' }}>Unusual Activity</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>
                    <Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}>
                        <img src='./assets/images/app-activity/insights/question-icon.svg' className='img-fluid' alt='question icon' />
                    </Button>
                    <Link to='/feature'>
                    <Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><SettingsIcon /></Button>
                    </Link>
                </Box>
            </Box>
            <Box sx={{ width: '100%' }}>
                <Box className="d-flex justify-content-between align-items-center flex-wrap">
                    <Box className="d-flex gap-10 align-items-center">
                        <GroupedSelect
                            label="Select Project"
                            options={projects}
                            selectedValues={selectedProjects}
                            onChange={setSelectedProjects}
                        />
                        <SingalUserImageSelect
                            label="Select User"
                            options={userList}
                            selectedValue={selectedUser}
                            onChange={setSelectedUser}
                        />
                    </Box>

                    <Box className="d-flex gap-10 align-items-center" sx={{ marginTop: { sm: '10px' } }}>

                        {/* <SingleDatePicker /> */}
                        <DateRangePicker/>

                    </Box>
                </Box>
            </Box>
            <Box sx={{ margin: '18px auto 32px' }}><UnusualDataCard /></Box>
            <div>
                <UpgradeToGetStarted
                    imageSrc="./assets/images/app-activity/insights/insights-no-data.png"
                    imageAlt="insights no data"
                    heading="Insights"
                    description="Boost your team’s productivity with powerful analytics — track trends across members and projects, identify top and low performers, and uncover time spent on unproductive apps and URLs."
                    lockIconSrc="./assets/images/app-activity/insights/lock-icon.svg"
                    promoText="Schedule a call with our sales team to discover more about Insights."
                    buttonText="Upgrade to get started"
                />
            </div>


            {/* <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #DFDFDF', borderRadius: '8px' }}>
                <img src='./assets/images/app-activity/insights/insights-no-data.png' className='img-fluid' alt='insights no data' />
                <Typography sx={{ fontSize: '32px', color: '#1A1F36', fontWeight: '600', margin: '48px auto 12px' }}>Insights</Typography>
                <Typography sx={{ fontSize: '16px', color: '#373737', fontWeight: '400', maxWidth: '550px' }}>Boost your team’s productivity with powerful analytics — track trends across members and projects, identify top and low performers, and uncover time spent on unproductive apps and URLs.</Typography>

                <Box sx={{
                    display: { xs: 'block', sm: 'block', md: 'block', lg: 'flex' },
                    alignItems: { sm: 'center' }, // Only applies from 'sm' and up
                    justifyContent: { sm: 'space-between' },
                    gap: { xs: 2, sm: 3 }, gap: 22, backgroundColor: '#0076FE0A', padding: '20px 12px', border: '1px solid #0076FE', borderRadius: '8px', margin: '48px auto', height: { md: 'auto', lg: '80px' }
                }}>
                    <Typography sx={{ whiteSpace: 'nowrap', fontSize: '16px', fontWeight: '500', color: '#0076FE', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <img src='./assets/images/app-activity/insights/lock-icon.svg' className='img-fluid' alt='Lock Icon' />
                        Schedule a call with our sales team to discover more about Insights.</Typography>
                    <button style={{ whiteSpace: 'nowrap', fontSize: '16px', fontWeight: '600', color: '#FFFFFF', padding: '8px 24px', backgroundColor: '#0076FE', borderRadius: '100px' }}>Upgrade to get started</button>
                </Box>
            </div> */}
        </div>
    )
}

export default UnusualActivity
